import { Typography } from '@vp/swan';
import { markdownBoldTextParser } from '../../../../utils/markdownBoldTextParser';

interface StatTextProps {
    text: string;
}

const StatText = ({ text }: StatTextProps) => {
    const parsedTextParts = markdownBoldTextParser(text);

    return (
        <>
            {parsedTextParts.map(({ text, isBold }, index) => {
                return (
                    <Typography
                        key={index}
                        fontSkin={isBold ? 'title-display' : 'title-section'}
                        display={isBold ? 'block' : 'inline'}
                        as="span"
                        marginTop={0}
                        marginBottom={4}
                    >
                        {text}
                    </Typography>
                );
            })}
        </>
    );
};

export default StatText;
